module.exports = __webpack_public_path__ + "static/GalanoGrotesque-Regular-72689e7710ccb94283948ed1533af7bb.woff";